<template>
  <div class="content container-fluid">
    <!-- Page Header -->
    <div class="page-header">
      <div class="row align-items-center">
        <div class="col">
          <h3 class="page-title">Manage FWA Setup</h3>
        </div>
      </div>
    </div>
    <!-- /Page Header -->

    <!-- Form -->
    <form @submit.prevent="save">
      <div class="form-group row align-items-center">
        <label class="col-md-2 mb-0 fit-content">Company</label>
        <div class="col-md-5 pl-md-0 fit-content">
          <select class="custom-select" v-model="company" @change="getFwaSetup">
            <option
              v-for="(item, i) in companies"
              :key="i"
              :value="item.CompanyName"
            >
              {{ item.CompanyName }}
            </option>
          </select>
        </div>
      </div>
      <div class="form-group row align-items-center mt-5">
        <label class="col-md-4 mb-0 pr-0 fit-content">
          Minimum days per application
        </label>
        <div class="col-md-2 w-100">
          <input
            type="number"
            class="form-control"
            v-model="minDaysPerApp"
            min="1"
            step="1"
          />
        </div>
      </div>
      <div class="form-group row align-items-center">
        <label class="col-md-4 mb-0 pr-0 fit-content">
          Maximum days per application
        </label>
        <div class="col-md-2 w-100">
          <input
            type="number"
            class="form-control"
            v-model="maxDaysPerApp"
            min="1"
            step="1"
          />
        </div>
      </div>
      <div class="form-group row align-items-center">
        <label class="col-md-4 mb-0 pr-0 fit-content">
          Maximum Number of Times per Year
        </label>
        <div class="col-md-2 w-100">
          <input
            type="number"
            class="form-control"
            v-model="maxNumberPerYear"
            min="1"
            step="1"
          />
        </div>
      </div>
      <div class="form-group row align-items-center">
        <label class="col-md-4 mb-0 pr-0 fit-content">
          Minimum Advanced Application
        </label>
        <div class="col-md-2 w-100">
          <input
            type="number"
            class="form-control"
            v-model="minAdvancedAppDays"
            min="1"
            step="1"
          />
        </div>
        <label class="col-md-1 mb-0 pl-0">day(s)</label>
      </div>
      <div class="form-group row align-items-center">
        <div class="col-md-1">
          <button type="submit" class="btn btn-primary">Save</button>
        </div>
      </div>
    </form>
    <!-- /Form -->
  </div>
</template>

<script>
import API from "../../http-common.js";
import config from "../../config.js";
export default {
  data() {
    return {
      companies: [],
      company: config.DEFAULT_COMPANY,
      minDaysPerApp: null,
      maxDaysPerApp: null,
      maxNumberPerYear: null,
      minAdvancedAppDays: null,
    };
  },
  computed: {
    token() {
      let data = JSON.parse(localStorage.getItem("lambitoken"));
      return data.Token;
    },
    role() {
      let data = JSON.parse(localStorage.getItem("lambitoken"));
      return data.Role;
    },
  },
  methods: {
    getCompanies() {
      let param = {
        Token: this.token,
      };
      this.$store.state.isLoading = true;
      API.getCompanies(param)
        .then((response) => {
          this.$store.state.isLoading = false;
          if (response.data.success) {
            this.companies = response.data.record;
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    getFwaSetup() {
      let param = {
        Token: this.token,
        Company: this.company,
      };
      this.$store.state.isLoading = true;
      API.getFwaSetup(param)
        .then((response) => {
          this.$store.state.isLoading = false;
          if (response.data.success) {
            let data = response.data.record;
            if (data) {
              this.minDaysPerApp = data.MinDaysPerApp;
              this.maxDaysPerApp = data.MaxDaysPerApp;
              this.maxNumberPerYear = data.MaxNumberPerYear;
              this.minAdvancedAppDays = data.MinAdvancedAppDays;
            } else {
              this.resetData();
            }
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    save() {
      let param = {
        Token: this.token,
        Company: this.company,
        MinDaysPerApp: this.minDaysPerApp,
        MaxDaysPerApp: this.maxDaysPerApp,
        MaxNumberPerYear: this.maxNumberPerYear,
        MinAdvancedAppDays: this.minAdvancedAppDays,
      };
      this.$swal({
        title: "Are you sure?",
        text: "Are you sure you want to save the setup?",
        icon: "info",
        buttons: true,
        dangerMode: false,
      }).then((willSave) => {
        if (willSave) {
          this.$store.state.isLoading = true;
          API.saveFwaSetup(param)
            .then((response) => {
              this.$store.state.isLoading = false;
              this.$swal(response.data.message, {
                icon: response.data.success ? "success" : "error",
              });
            })
            .catch((error) => {
              this.$store.state.isLoading = false;
              this.$swal(error.response.data.Message, { icon: "error" });
            });
        }
      });
    },
    resetData() {
      this.minDaysPerApp = null;
      this.maxDaysPerApp = null;
      this.maxNumberPerYear = null;
      this.minAdvancedAppDays = null;
    },
  },
  created() {
    if (this.role != "admin") {
      this.$router.replace({ name: "home" });
    }
    this.getCompanies();
    this.getFwaSetup();
  },
};
</script>

<style scoped>
.fit-content {
  max-width: fit-content;
}

.w-100 {
  max-width: 100px;
}
</style>


// WEBPACK FOOTER //
// src/components/Fwa/FwaSetup.vue